export const USERS_PATH = '/users/'
export const DISC_PRESET_PATH = '/users/{uid}/presets/{discId}'
export const STOCK_SHOTS_PATH = '/users/{uid}/stock-shots'
export const DISC_PRESETS_COLLECTION_PATH = '/users/{uid}/presets'
export const THROW_SUMMARY_COLLECTION_PATH = '/users/{uid}/throw-summary/'
export const ADMIN_PATH = '/admin/'
export const ADMIN_SIMULATOR_PERMISSIONS_PATH = '/simulator/permissions'
export const ADMIN_SIMULATOR_COURSE_PATH = '/simulator/courses'
export const ADMIN_SIMULATOR_LAYOUT_PATH = '/simulator/layouts'
export const USER_PRICING_PLANS_PATH = '/admin/plans/users'
export const STORES_PRICING_PLANS_PATH = '/admin/plans/stores'

export const ANALYSIS_SET_COLLECTION_PATH = '/users/{uid}/analysis-set/'
export const USER_DEVICES_COLLECTION_PATH = '/users/{uid}/devices/'
export const DEVICES_COLLECTION_PATH = '/devices/'
export const DEVICES_CALIBRATION_COLLECTION_PATH = '/users/{uid}/devices/{deviceId}/calibration/'
export const STRIPE_CHECKOUT_SESSION_COLLECTION_PATH =
    '/stripe/data/customers/{uid}/checkout_sessions'
export const LEADERBOARD_USER_METADATA_COLLECTION_PATH = '/leaderboard/users/userMetadata'
export const LEADERBOARD_STORE_METADATA_COLLECTION_PATH = '/leaderboard/users/storeMetadata'
export const LEADERBOARD_WEEKLY_COLLECTION_PATH = '/leaderboard/dates/weekly/'

export const USER_THROW_VIDEO_STORAGE_PATH = '/throw-video/{uid}/{throwId}'

export const LEADERBOARD_LAYOUTS_DOC = '/leaderboard/layouts'
export const LEADERBOARD_PLAY_DOC = '/leaderboard/play-events'

export const RAW_THROW_STORAGE_PATH = '/raw-throws/{uid}/{throwId}.throw'
export const RAW_FLIGHT_STORAGE_PATH = '/raw-throws/{uid}/{throwId}.flight'

export const TRACK_STORAGE_PATH = '/{trackType}-track/{uid}/{throwId}.throw'

export const USER_ADMIN_COLLECTION_PATH = '/user-admin'
export const ADMIN_SIMULATOR_LAYOUTS_COLLECTION_PATH = '/admin/simulator/layouts'
export const ADMIN_SIMULATOR_CHALLENGES_COLLECTION_PATH = '/admin/simulator/challenges'
export const ADMIN_USER_ROLES_COLLECTION_PATH = '/admin/users/roles'
export const ADMIN_LIVE_EVENTS_COLLECTION_PATH = '/admin/events/live'
export const ADMIN_PLAY_EVENTS_COLLECTION_PATH = '/admin/events/play'
export const ADMIN_COURSES_COLLECTION_PATH = '/admin/simulator/courses/'
export const PROMOTED_COURSES_COLLECTION_PATH = '/admin/promotions/courses'
export const ADMIN_SIMULATOR_PERMISSIONS_COLLECTION_PATH = '/admin/simulator/permissions/'

export const PUBLIC_USER_PRESETS_COLLECTION_PATH = '/users/public/presets'
export const CONTACTS_COLLECTION_PATH = '/contacts'
